
import { v4 as uuidv4 } from "uuid";
import { FloatingFeature } from "@models";
import { DAMAGE_TYPES } from "@dndModels/Constants";
import { DamageType, isDamageType } from "@dndModels/Types";

export class DamageMultiplier extends FloatingFeature {
  the_damage_types: (DamageType | "Selectable Key" | "Use Extra")[] = [];
  multiplier = 0; // Immunity = 0, Resistance = 0.5, Vulnerability = 2
  details = "";
  selectable_key = "";
  multiplier_improvement: boolean = false;

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      const the_damage_types: string[] = obj.the_damage_types ? obj.the_damage_types : (obj.damage_types ? obj.damage_types : []);
      this.multiplier = obj.multiplier ? obj.multiplier : 0;
      this.multiplier_improvement = obj.multiplier_improvement ? obj.multiplier_improvement : false;
      this.details = obj.details ? obj.details : "";
      this.selectable_key = obj.selectable_key ? obj.selectable_key : "";
      
      this.the_damage_types = the_damage_types.map(o => {
        const dt = o[0].toLocaleUpperCase() + o.substring(1);
        if (isDamageType(dt) || dt === "Selectable Key" || dt === "Use Extra") {
          return dt;
        }
        return "";
      }).filter(o => o !== "") as (DamageType | "Selectable Key" | "Use Extra")[];
    }
  }

  get damage_types() {
    return this.the_damage_types.filter(o => isDamageType(o)) as DamageType[];
  }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      the_damage_types: this.the_damage_types,
      multiplier: this.multiplier,
      multiplier_improvement: this.multiplier_improvement,
      details: this.details,
      selectable_key: this.selectable_key
    };
  }

  toString(): string {
    let return_me = "";
    this.the_damage_types.forEach(dt => {
      if (return_me.length > 0) {
        return_me += ", ";
      }
      return_me += dt;
    });
    if (this.selectable_key !== "") {
      if (return_me.length > 0) {
        return_me += ", ";
      }
      return_me += this.selectable_key;
    }
    if (this.details !== "") {
      return_me += ` (${this.details})`;
    }
    return return_me;
  }
  
  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof DamageMultiplier) {
      this.safe_copy(copyMe);
    }
  }

  safe_copy(copyMe: DamageMultiplier) {
    this.the_damage_types = [...copyMe.the_damage_types];
    this.multiplier = copyMe.multiplier;
    this.multiplier_improvement = copyMe.multiplier_improvement;
    this.details = copyMe.details;
    this.selectable_key = copyMe.selectable_key;
  }

  clone(drop_ids = false): DamageMultiplier {
    const new_obj = new DamageMultiplier();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}

export class DamageMultiplierSimple {
  true_id: string;
  damage_type: DamageType | "";
  multiplier: number;
  multiplier_improvement: boolean;
  details: string;
  from_feature: boolean;

  constructor(obj?: any) {
    this.true_id = obj ? obj.true_id : uuidv4().toString();
    this.damage_type = obj ? obj.damage_type : "";
    this.multiplier = obj ? obj.multiplier : 0;
    this.multiplier_improvement = obj && obj.multiplier_improvement ? obj.multiplier_improvement : false;
    this.details = obj && obj.details ? obj.details : "";
    this.from_feature = obj ? obj.from_feature : false;
  }

  toDBObj(): any {
    return {
      damage_type: this.damage_type,
      multiplier: this.multiplier,
      multiplier_improvement: this.multiplier_improvement,
      details: this.details,
      from_feature: this.from_feature
    };
  }

  clone(drop_ids = false): DamageMultiplierSimple {
    const clone = new DamageMultiplierSimple();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: DamageMultiplierSimple, drop_ids = false): void {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
    }
    this.damage_type = copyMe.damage_type;
    this.multiplier = copyMe.multiplier;
    this.multiplier_improvement = copyMe.multiplier_improvement;
    this.details = copyMe.details;
    this.from_feature = copyMe.from_feature;
  }
}